<template>
    <el-main class="main-con el-main">
        <nav-breadcrumb :menu="[{label: '版本更新记录'}]"/>
        <ul class="Edition-list of">
            <li>
                <div class="Edition-list-title">2024.03.09 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增法务大数据查询：对接第三方法海风控大数据查询风控大数据，分按个人/按企业通过接口查询法海风控的风险数据并展示。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.12.16 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.与贷款相关合同和表单中的法人信息变更：从2023年12月6日开始生成的与贷款相关的合同、表单等材料中法人信息变更为新的法人信息；</p>
                    <p>2. 兴业银行还款流水数据模板变动，对应升级兴业银行还款流水数据的导入模板。（2023年12月11日已更新）。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.11.11 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增江苏省/常州市/市辖区、江苏省/常州市/武进区的办押表单，市辖区、武进区同用一套抵押登记申请书、承诺书和委托书；新增江苏省/常州市/市辖区、江苏省/常州市/武进区的撤押表单，市辖区、武进区同用一套撤押的撤押注销申请书和委托书；</p>
                    <p>2.新增江苏省/苏州市/工业园区的不动产登记申请书、委托书。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.08.26 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.微信公众号审核进件增加显示风控材料。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.08.19 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.微信公众号上审核用款申请时，要增加显示当前用款的进件审批流程显示（由法务提出）；</p>
                    <p>2.微信公众号审核进件界面上将评估信息调整至第二个Tab页，即显示在客户信息之后。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.08.12 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.用款申请中增加一个上传其他佐证文件。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.07.22 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.考虑客户信息安全，故系统中所有功能列表中的“客户手机号”一列全部隐藏，以免客户手机号信息可批量复制。详情页面中的手机号信息不做隐藏。以便业务员查询。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.07.01 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增审批流程中申请人可撤回功能：在进件、签约、用款、他项出库审批流程中，申请人发现申请资料有误，需撤回申请后重新提交申请；</p>
                    <p>2.新增在途申请统计：增加一个在途申请的清单列表，即统计审批流程没有审核结束的申请；</p>
                    <p>3.债转台账列表和导出Excel表中增加一列“贷款金额”（财务提出）。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.06.10 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增招商银行还款流水数据导入模板；</p>
                    <p>2.系统中户名是无锡市金鑫互联网科技小额贷款有限公司的账户全部禁用，新增联投账户；</p>
                    <p>3.债转台账中增加债转日期的搜索条件（财务提出）。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.05.27 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.发起签约时增加选定放款账户；</p>
                    <p>2.优化先息后本逾期多次还款计算罚息和复利的逻辑；</p>
                    <p>3.优化后台管理系统在手机端和平板端的适配问题；</p>
                    <p>4.债转里的下载撤押申请函中公司名称改为新的公司名称：无锡市联投科技小额贷款有限公司（因债转贷款的撤押是需债转后结清贷款才能申请撤押，所以申请函的时间不以债转时间为分界点）；</p>
                    <p>5.发起签约用印时，江阴的签约用印需要再增加一个法人身份证文件。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.05.20 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增渠道PC端进件登记功能。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.05.13 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.变更系统名和贷款合同相关编号生成规则。</p>
                    <p>2.仪表盘的标题改为“联投金融聚合可视化平台”。</p>
                    <p>3.系统中所有导出Excel功能中表头中的公司名称改为新公司名：无锡市联投科技小额贷款有限公司。</p>
                    <p>4.渠道微信端“登录并绑定”页面的用户注册协议要变更成新的公司。</p>
                    <p>5.资方PC端的导出“贷款清算表”Excel表中的公司名称改为新公司名：无锡市联投科技小额贷款有限公司。</p>
                    <p>6.首页适配优化。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.05.10 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.因金鑫公司名称变更，需变更系统的签约相关合同和表单中的公司名称以及银行账户，从2023年5月11日开始系统启用新公司名称和新银行户名。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.04.29 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.在用印申请审批过程中新增申请人撤回用印申请功能。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.03.25 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.发起债转用印时，系统自动将债转协议带出，并且文件份数默认为2份。</p>
                    <p>2.变更自营贷款的借款合同的条款内容：将自营贷款的借款合同中的“第十一条 其他事项”下的“6个月内不得提前还款。”的文字去除，其他渠道的借款合同不变。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.02.04 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.他项出库申请中，因代理人可能是渠道的业务人，并非全是金鑫人员，需在撤押时，手工填写代理人，因此需将代理人改成是非必填。表三和委托书需要做相应变更，不显示代理人。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2023.01.20 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.发起用款申请时，如果是渠道商是自营的（即渠道等级为一级渠道商），推荐函改为非必填项；其他渠道商还是必填项；</p>
                    <p>2.渠道商是自营的，贷款合同里的还款账号要变更成最新还款账户；</p>
                    <p>3.新增江阴不动产抵押注销申请表。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.12.03 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.变更进件、用印和用款的审批流程(增加法务副总审核节点）；</p>
                    <p>2.优化审批中预览审批资料的方式；</p>
                    <p>3.优化金鑫公众号端的审批界面。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.11.09 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.签约、撤押、助贷函件、债转、诉讼、业务相关用印审批流程：<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;需盖公章、法人章的流程：项目申请人->业务负责人->风控审核->副总审核->总经理审核->法人审核->综合岗（公章）->综合岗（法人章）<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;需盖公章的流程：项目申请人->业务负责人->风控审核->副总审核->总经理审核->综合岗（公章）</p>
                    <p>2.服务费支付用印审批流程：<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;需盖公章的流程：项目申请人->业务负责人->财务初审->财务审核->风控审核->副总审核->总经理审核->综合岗（公章） </p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.11.06 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.取消签约用印申请中副总审核->总经理审核两个节点自动通过的功能；</p>
                    <p>2.若需用法人章，需在“总经理审核”后增加一个“法人审核”的节点，最后到综合岗（法人章）节点的用印人。 </p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.10.31 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.进件审批：新增一个“业务负责人”审批节点，审批流程变为：项目申请人->业务负责人->风控审核->副总审核->总经理审核；业务审查表的审批流程要修改；</p>
                    <p>2.贷款审核：审批流程变为：项目申请人->副总审核->总经理审核；</p>
                    <p>3.用款申请：审批流程变为：项目申请人->业务负责人->财务初审->风控审核->副总审核->总经理审核->财务复核。财务初审需验证保证是否充足，风控需要材料核实， 去掉之前财务总监的节点；用款申请审批表的审批流程要修改；</p>
                    <p>4.用印申请：所有流程中风控审核改为副总审核，其中签约用印申请发起后，副总审核->总经理审核，两个节点自动通过。打印审批表的审批流程要修改，流程图要文字要修改；</p>
                    <p>5.变更逾期还款罚息复利的计算逻辑。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.10.15 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.首页代办事项中新增“待审核债转”；</p>
                    <p>2.客户贷款中，办押时“无锡市区”的表三新增两个条款；</p>
                    <p>3.他项出入库列表中的，撤押时“无锡市区”的表三也新增两个条款。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.09.10 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1. 进件审批：增加一个“副总审核”的节点，审批流程变为：进件送签->审查授信->风控审核->副总审核->总经理审核；其中两个连续节点只有一个能审核的用户，则只审核一次，后续一个节点自动审核。审核通过时，前一个节点审核通过了，后一个节点也自动审核通过；审核不通过时，前一个节点审核不通过，后一个节点就无需自动审核；</p>
                    <p>2. 提前还款：在提前还款增加一个“导出”按钮，按设置条件导出提前还款的Excel表；</p>
                    <p>3. 他项出库：他项出库增加一个副总审核，流程变为：提交申请->副总审核->财务复核->总经理 ->综合岗审核；</p>
                    <p>4. 变更导出余额收息表的搜索条件。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.08.27 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增债转审批流程；</p>
                    <p>2.渠道PC端新增下载债转申请函。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.08.13 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.发起签约时增加抵押物备注信息；</p>
                    <p>2.新增江阴业务的表单；</p>
                    <p>3.后台增加待审核贷款查询；</p>
                    <p>4.他项出库在提交申请后即可打印表单；</p>
                    <p>5.办押（客户贷款）和撤押（他项出库）中的表三和单位委托书增加打印时可以更换新的代理人，但不改变申请单里的数据。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.06.11 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.资方端的还款登记中批量还款时增加填写还款日期。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.06.03 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.意向客户审批时新增名义评估价的取值规则和验证。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.04.30 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.变更他项入库逻辑以及增贷出库申请；</p>
                    <p>2.新增先息后本的贷款（最后一期还款日是近三个月的贷款）可以操作一次延期（延期数为3期）的功能。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.04.02 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增一个业务相关用印流程；</p>
                    <p>2.新增签约用印选择贷款后自动带出用印文件；</p>
                    <p>3.新增渠道代偿登记功能;</p>
                    <p>4.他项释放审批表和用印审批表页脚增加打印人和打印时间显示；</p>
                    <p>5.银行流水收息明细表中将整笔宕账的余额处理方式显示为“宕账”；</p>
                    <p>6.委托进件增加下载推荐函功能；</p>
                    <p>7.他项出库表单《结清证明》中的截止和落款日期改取申请时间的日期；</p>
                    <p>8.删除借款合同中的第三条 贷款人权利和义务的部分内容（3月22日已更新）。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.03.12 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增对还款余额的处理规则：系统自动实现将还款后余额20元以下（包含20）全都计入营业外，20元以上都转入下期；同步修改以下功能模块逻辑：自动匹配还款、转账确认还款以及还款审核中的逻辑；</p>
                    <p>2.新增他项出库表单：撤押表三、委托书和结清证明的下载；</p>
                    <p>3.新增银行流水整笔宕账功能并转入下期还款;</p>
                    <p>4.债转管理中增加一个导出Excel表功能（所见即所得）。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.02.26 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.进件时共借人增加上传共借人户口本；</p>
                    <p>2.优化系统中的日期搜索条件：查看某时间段数据设置的时间范围条件无需将结束日期延后一天；</p>
                    <p>3.调整债转台账详情中的“查看还款信息”弹出框的大小；</p>
                    <p>4.修正助贷月还款明细报表中超宽限期提示信息；</p>
                    <p>5.渠道端增加查看贷款还款明细。</p>
                </div>
            </li>

            <li>
                <div class="Edition-list-title">2022.02.19 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增余额还款收息功能；</p>
                    <p>2.优化客户还款余额表的报表格式；</p>
                    <p>3.新增释放他项权证审批表；</p>
                    <p>4.新增用印申请中重新发起申请功能；</p>
                    <p>5.新增签约、撤押、助贷函件、债转、讼诉和服务费支付用印审批表；</p>
                    <p>6.新增用款申请流程图。</p>
                </div>
            </li>

            <li>
                <div class="Edition-list-title">2022.02.13 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.新增用印管理模块：签约用印、助贷函件用印、债转用印、撤押用印、诉讼用印和服务费支付用印；</p>
                    <p>2.用款申请审批流程变更，启用最新审核流程：提交申请——内勤核实——财务初审——总经理审核——财务审核——财务总监审核；</p>
                    <p>3.新增在线生成借款借据表单。</p>
                    <p>4.发起用款申请时增加上传抵押合同。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2022.01.22 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1. 助贷还款登记增加部分还款功能；</p>
                    <p>2. 渠道逾期贷款列表增加差额信息；</p>
                    <p>3. 金鑫仪表盘优化项：
                    1)业务统计签约率的绿色改为自营业务中进件笔数字体的颜色；
                    2)月度统计移至右侧第二个；
                    3)原月度统计区域新增一个无锡市区域图；
                    4)中间地图的图标改新样式展示,弹出框自动轮流按序弹出关闭；
                    5)抵押等级+借款人婚姻状况+抵押物性质全部用饼状图显示，叠加在一个区域轮番滚动；
                    6)右侧最下面展示最新事件。</p>
                </div>
            </li>
        <li>
            <div class="Edition-list-title">2022.01.08 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1. 新增金鑫金融聚合可视化平台；</p>
                <p>2. 新增债转登记簿模块；</p>
                <p>3. 优化用款申请中的支付审核节点邮件通知内容；</p>
                <p>4.菜单调整：“渠道管理”改为“合作方管理”，“资方管理”改为“助贷业务”，将以下功能“技术合作方”、“资管公司”、“资方列表”和“资方用户”移至合作方管理模块，将“缴纳保证金”和“保证金台账”移至资金管理模块。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.12.25 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.用款申请流程中再增加两个节点（支付录入和支付审核），原有的“财务总监审核”节点标题变更“财务审核”；</p>
                <p>2.新增合作方模块；</p>
                <p>3.进件审查时，增加抵押物为二抵时，一抵余额和一抵债权金额验证为必填，若未填则需要提醒用户一抵余额和一抵债权金额不能为空；</p>
                <p>4.在发起签约时，增加验证贷款期限要在抵押期限范围内，不能超出抵押期限；</p>
                <p>5.修复bug：解决在发起签约，在填写抵押备注时清空了已填写的抵押合同号，需要重新填写一次的问题。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.11.27 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.抵押合同段落间距改成与借款合同一致；</p>
                <p>2.表三中的备注按抵押物分别显示：抵押物为一抵则显示空白；抵押物为二抵则显示余额抵押；</p>
                <p>3.进件审查时，点击审核通过时增加验证 抵押物名义评估价之和-一抵债权金额之和>申贷金额，否则需提示“抵押物可贷金额低于申贷金额！”不能审核通过；</p>
                <p>4.修复抵押物清单中多套抵押物时未显示完整；</p>
                <p>5.增加对系统上线前存量客户信息的资料维护完善功能。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.11.13 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.优化逾期还款中多次还款的计算逻辑；</p>
                <p>2.修复抵押合同中的抵押人住所信息的显示。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.10.15 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.抵押合同中债务人是借款人和所有共借人（目前只显示抵押人）；</p>
                <p>2.抵押合同封面样式改成借款合同封面样式；</p>
                <p>3.单位委托书中办理的业务勾选项布局改成样本中样式，向左对齐；</p>
                <p>4.贷款告知客户书中间距加大，排满一页；</p>
                <p>5.抵押物清单的签字盖章栏也大一些。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.10.10 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.新增资方端贷款清算表和月还款明细表；</p>
                <p>2.新增渠道微信端到期贷款提醒；</p>
                <p>3.优化助贷业务中提前还款的清算逻辑；（9月15日已更新）</p>
                <p>4.处理贷款表单的Bug和优化项。（9月11日已更新）</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.09.04 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.新增一个渠道商用户关联多个渠道商，渠道微信端新增切换渠道功能；</p>
                <p>2.签约时新增抵押合同的抵押期限，以及显示债权最高本金余额和暂作价；</p>
                <p>3.调整表三字体大小和布局。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.08.21 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.助贷在金鑫审查时增加风控附件以及审批通过后资方可以下载推荐表；</p>
                <p>2.新增助贷渠道清算表和助贷资方清算表；</p>
                <p>3.优化助贷月还款明细、助贷清算报表和助贷放款明细表三个报表。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.08.07 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.新增助贷业务四个报表：助贷月还款明细、助贷清算报表、日均助贷余额表和助贷放款明细表；</p>
                <p>2.资方分配列表中增加进件状态和委托状态的显示，委托状态： 待受理 、贷款成功、已被拒贷和已撤回四种；</p>
                <p>3.委托进件中增加可查询已被拒贷的进件记录，并增加委托状态的显示；</p>
                <p>4.首页代办事项中增加已被拒贷笔数的统计；</p>
                <p>5.贷款下载表单中的bug和优化。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.07.24 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.增加自动生成抵押合同、表三、委托书和告知书；</p>
                <p>2.后台首页到期贷款提醒按到期日升序排序；</p>
                <p>3.资方分配列表中增加资方一列，并按进件倒序排列；</p>
                <p>4.助贷查询中列表上的进件时间改为登记时间，并按开始日期倒序排列；</p>
                <p>5.委托进件列表按进件时间倒序排列；</p>
                <p>6.资方端客户进件列表和登记放款列表按进件时间倒序排列。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.06.26 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.在渠道商模块增加一个标志设置，设置当前渠道商是否为助贷渠道商。在进件审批通过后，只有助贷渠道商的进件才显示在资方分配的待分配列表，其他的显示在发起签约列表中；</p>
                <p>2.在委托进件和助贷查询里增加导出客户业务审查表。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.06.12 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.新增他项权证管理模块；</p>
                <p>2.新增首页到期贷款排序；</p>
                <p>3.存量未出库他项数据导入。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.05.22 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.后台管理端新增助贷模块（资方管理）；</p>
                <p>2.新增资方入口和业务操作系统；</p>
                <p>3.优化进件审查时名义评估价的触发机制。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.03.27 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.进件时实现支持多套抵押物；</p>
                <p>2.贷款编号自动生成机制改为在进件审批通过立即生成编号并占用；</p>
                <p>3.放款明细表、未结清贷款明细和利息收入明细表在报表最下面增加合计信息。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.02.27 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.客户贷款增加各节点链接；</p>
                <p>2.渠道商微信端增加逾期报表；</p>
                <p>3.增加自动生成贷款编号机制；</p>
                <p>4.借款合同中第一条借款的第5项内容变更；（2月24日已加急升级）</p>
                <p>5.提前还款页面中增加显示应还本金、应还利息、应付罚息、应付复利。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.02.06 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.首页改版内容：
                    1）增加当前在途数据（签约中客户数、在途签约合同、实时贷款余额），业务统计将分成三部分：累计数据（现有累计数据统计不变，按原逻辑）、在途数据（签约中客户数、在途签约合同、实时贷款余额）、实时数据（当前逾期、本年度放款金额）；
                    2）首页贷款月度统计中贷款笔数和贷款金额柱状图和折线交换一下；
                    3）首页去掉按渠道商显示，改为按贷款产品年限（一年、三年、五年、八年）统计显示。
                </p>
                <p>2.微信端渠道商进件时增加上传婚档pdf（婚姻状态为离异时必填）、产调png（必填项）、经营佐证和其他资料（非必填项），后台管理端关联功能对应增加婚档pdf、产调png、经营佐证和其他资料；</p>
                <p>3.逾期贷款报表中增加渠道商搜索条件，列表上也增加一列渠道商信息，以及导出功能中也相应增加；</p>
                <p>4.待办事项中增加待分配申贷。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2021.01.23 投产以下功能：</div>
            <div class="Edition-list-con">
                <p>1.新增公众号上客户申贷功能；</p>
                <p>2.后台首页新增到期贷款提醒；</p>
                <p>3.渠道商微信端进件时，根据婚姻状态来动态显示上传图片。未婚：只上传单身证明；已婚：配偶身份证正反面、结婚证；离异：离婚证；</p>
                <p>4.首页逾期贷款统计笔数增加超链接至逾期贷款报表。</p>
            </div>
        </li>
        <li>
            <div class="Edition-list-title">2020.11.28 投产以下功能</div>
            <div class="Edition-list-con">
                <p>1. 增加提前还款时一笔流水也可以按照实际情况设置提前还款日期。</p>
            </div>
        </li>
          <li>
            <div class="Edition-list-title">2020.11.21 投产以下功能</div>
            <div class="Edition-list-con">
              <p>1. 根据兴业银行11.12升级后的流水导出格式升级系统流水导入功能。</p>
            </div>
          </li>
          <li>
            <div class="Edition-list-title">2020.11.7 投产以下功能</div>
            <div class="Edition-list-con">
              <p>1. 增加部分提前还款功能；</p>
              <p>2. 增加贷款编号增加编号唯一的验证规则：增加编号唯一的验证规则：贷款状态在有效状态（待审核、待放款、放款中、还款中、已还清）情况下，验证 “年份 + 四位序列号 ”不能重复。</p>
            </div>
          </li>

            <li>
              <div class="Edition-list-title">2020.10.17 投产以下功能</div>
              <div class="Edition-list-con">
                <p>1.贷款清算明细表计算逻辑变更；</p>
                <p>2.用款申请详情增加保证金可贷余额显示，用款申请审批表增加保证金可贷余额显示；</p>
                <p>3.渠道商PC端增加下载贷款的还款计划表功能；</p>
                <p>4.银行流水收息明细表中增加一列差额；</p>
                <p>5.渠道商端微信端和PC端隐藏客户手机号和身份证号码。</p>
              </div>
            </li>
            <li>
              <div class="Edition-list-title">2020.9.26 投产以下功能</div>
              <div class="Edition-list-con">
                <p>1.新增渠道商保证金模块，包含缴退保证金发起和复核，保证金台账以及在用款时实时显示渠道商可贷余额；</p>
                <p>2.客户贷款列表中增加一个还款方式搜索条件，并且列表中也显示还款方式。</p>
              </div>
            </li>
            <li>
              <div class="Edition-list-title">2020.9.12 投产以下功能</div>
              <div class="Edition-list-con">
                <p>1. 新增设置贷款的罚息复利率功能；</p>
                <p>2. 新增进件和签约贷款合同作废功能；</p>
                <p>3.增加下载贷款的还款计划表功能。</p>
              </div>
            </li>
            <li>
              <div class="Edition-list-title">2020.8.28 投产以下功能</div>
              <div class="Edition-list-con">
                <p>1.新增先息后本贷款到期后延期还款收息功能；</p>
                <p>2.新增拆分银行流水匹配贷款功能；</p>
                <p>3.新增微信端渠道商查询到期还款额；</p>
                <p>4.优化意向进件中，审查环节时变更贷款产品时期限联动变更。</p>
              </div>
            </li>
            <li>
              <div class="Edition-list-title">2020.8.15 投产以下功能</div>
              <div class="Edition-list-con">
                <p>1.新增导出银行流水收息明细表；</p>
                <p>2.新增银行流水使用明细打印功能；</p>
                <p>3.新增意向进件审查时的暂存。</p>
              </div>
            </li>
            <li>
                <div class="Edition-list-title">2020.8.6 投产以下功能</div>
                <div class="Edition-list-con">
                  <p>1.优化贷款清算明细表：按照渠道商的所有客户还清才能结算当期费用，清算渠道商只清算利息，罚息复利不清算的规则重新修改了报表逻辑，导出的Excel中未还的用红色底高亮显示；</p>
                  <p>2.新增报表利息收入明细表；</p>
                  <p>3.新增银行流水使用明细表中按流水号、对方户名、贷款编号、客户姓名搜索；</p>
                  <p>4.优化未结清贷款明细报表：在选择日期后放款的贷款不能显示在报表中，在这一天还没有结清的，在这一天后放款的，肯定不在里面；比如选择的日期是7月30日，那么报表中7月30日放款的贷款要显示，7月31日放款的贷款不能显示。</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2020.7.23 投产以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.微信端渠道商增加提前还款试算功能；</p>
                    <p>2.转账还款确认页面增加一个“将共借人转账信息加入账户信息表”的功能，加入的共借人账户信息在贷款详情中的关联账户中查询；</p>
                    <p>3.按月还款明细报表 搜索条件“应还款日”文字改为“应还款月”，优化报表排序，贷款编号排序不区分（）进行顺序排序；</p>
                    <p>4.原来的“意向客户”名字改为“意向进件”，原来的“客户进件列表”名字改为“已授信进件”</p>
                    <p>5.增加一个已授信客户”，查看已授信客户的相关信息，为后续CRM做准备</p>
                </div>
            </li>
            <li>
                <div class="Edition-list-title">2020.7.16 投产了以下功能：</div>
                <div class="Edition-list-con">
                    <p>1.待放款列表中，放款登记页面中的放款日期不要带默认值</p>
                    <p>2.宽限期从7天改为28天</p>
                    <p>3.按月还款明细加一列还款码，并在贷款编号和差额上增加了排序功能</p>
                    <p>4.新增放款明细表</p>
                    <p>5.新增未结清贷款明细</p>
                    <p>6.业务审查表里新增了共借人信息显示，“贷款实际利率“文字”改为“留存收益率”</p>
                </div>
            </li>
          <li>
            <div class="Edition-list-title">2020.6.30 投产以下功能：</div>
            <div class="Edition-list-con">
              <p>1.在用款申请已审核的Tab页界面中，列表上新增用款审批表下载功能；</p>
              <p>2.发起用款申请时要增加他项权证号，并且在整个审批流程中都显示；</p>
              <p>3.业务审查表在发起签约后，改为以签约的贷款合同利率为准；</p>
              <p>4.意向客户审查时增加图片浏览时，翻转、缩放功能。</p>
              <p>另外新增了一些优化项：</p>
              <p>1.所有列表可以根据当时需要设置每页显示行数；</p>
              <p>2.发起签约时，贷款用途默认为空，不自动带进件时的贷款用途；</p>
              <p>3.发起签约时，还款方式不设默认值，以免没注意导致还款方式填写有误，系统提示为必填项；</p>
            </div>
          </li>
          <li>
            <div class="Edition-list-title">2020.6.24 投产以下功能：</div>
            <div class="Edition-list-con">
              <p>1.增加意向客户审查时暂存功能</p>
              <p>2.审核通过的贷款未发起用款申请时可以作废，重新签约；</p>
              <p>3.在收息确认和收息复核页面对提前还款的增加显示提前还款印章标志；</p>
              <p>4.增加用款审批表打印功能；</p>
              <p>5.用款申请时增加他项权证号的输入；</p>
              <p>6.审查页面图片浏览时要可以转换</p>
            </div>
          </li>
          <li>
            <div class="Edition-list-title">2020.6.21 投产以下功能：</div>
            <div class="Edition-list-con">
              <p>1.用款申请中增加抵押房产：抵押房屋信息中的位置；</p>
              <p>2.发起用款申请页面去掉“放款方式”的选择，在财务总监审批时必选“放款方式”。</p>
            </div>
          </li>
            <li>
              <div class="Edition-list-title">2020.6.17 投产以下功能：</div>
              <div class="Edition-list-con">
                <p>1.还款码：微信端渠道商可以在贷款查询中查到每笔贷款的还款码；后台在转账匹配时按还款码自动匹配还款；</p>
                <p>2.对于授信过程被否决的进件可以在不予授信客户列表中重新发起。</p>
              </div>
            </li>
            <li>
              <div class="Edition-list-title">2020.6.14 已经投产新功能：</div>
              <div class="Edition-list-con">
                <p>1.新增增贷业务：在发起签约功能中增加是否增贷，打勾时，则结束日期手工输入；并且在放款时，放款时间延后贷款结束日期不变。</p>
                <p>2.用款申请中界面增加月利率信息显示，在客户姓名右侧增加了业务审查表的查看，抵押房屋信息可在业务审查表中查看。</p>
                <p>3.贷款审核界面在客户姓名右侧增加了业务审查表的查看；</p>
                <p>4.渠道商微信端增加申贷金额验证不能少于1万元，目前已经出现两次答融进件时输入的申贷金额小于1万元了，所以增加此验证。</p>
              </div>
            </li>
        </ul>

    </el-main>
</template>

<script>
    export default {
        name: "Edition",
      data() {
        return {
          messageType: 'trade'
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/Edition.vue